import React, { useEffect, useState } from 'react';
import schema from './schema';
import uiSchema from './uiSchema';
import superadminSchema from './superadmin/schema';
import superadminUiSchema from './superadmin/uiSchema';
import { MuiFormBuilder } from 'components';
import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';

const Form = ({ formData = {}, onChange }) => {
  const [taskType, setTaskType] = useState();
  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);
  const isSuperadmin = isAuthenticated && hasRequiredRole(['superadmin'], userInfo?.roles);

  useEffect(() => {
    setTaskType(formData?.tariff?.task_type_id);
  }, [formData]);

  return (
    <MuiFormBuilder
      showSubmit={false}
      schema={isSuperadmin ? superadminSchema(taskType) : schema(taskType)}
      uiSchema={isSuperadmin ? superadminUiSchema(taskType) : uiSchema(taskType)}
      formData={formData}
      onChange={onChange}
    />
  );
};

export default Form;
